var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { DateConverter } from "./../../../converters/DateConverter";
export class DateRange {
  constructor(_data) {
    /**
     */
    __publicField(this, "From");
    /**
     */
    __publicField(this, "To");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof DateRange
     */
    __publicField(this, "$type", "V1.Primitives.DateRange");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    if (_data) {
      this.From = DateConverter.from(_data["From"]);
      this.To = DateConverter.from(_data["To"]);
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    _data["From"] = DateConverter.toUtcDateString(this.From);
    _data["To"] = DateConverter.toUtcDateString(this.To);
    return _data;
  }
}
